import React from 'react';
import { funnelData, campaignData } from '../utils/mockData';
import { StageMetricCard } from '../components/StageMetricCard';
import { FunnelChart } from '../components/FunnelChart';
import { CampaignTable } from '../components/CampaignTable';
import { BarChart3, Download, Filter, RefreshCw } from 'lucide-react';
export function SalesFunnelDashboard() {
  return <div className="min-h-screen bg-slate-50 p-4 md:p-8" data-id="element-123">
      <div className="max-w-7xl mx-auto space-y-8" data-id="element-124">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-125">
          <div data-id="element-126">
            <h1 className="text-2xl md:text-3xl font-bold text-slate-900 flex items-center gap-3" data-id="element-127">
              <BarChart3 className="text-blue-600" size={32} data-id="element-128" />
              Mortgage Pipeline Analytics
            </h1>
            <p className="text-slate-500 mt-1" data-id="element-129">
              Track lead progression from campaign to funding
            </p>
          </div>

          <div className="flex items-center gap-3" data-id="element-130">
            <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors shadow-sm text-sm font-medium" data-id="element-131">
              <Filter size={16} data-id="element-132" />
              Filter
            </button>
            <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-colors shadow-sm text-sm font-medium" data-id="element-133">
              <Download size={16} data-id="element-134" />
              Export
            </button>
            <button className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-sm text-sm font-medium" data-id="element-135">
              <RefreshCw size={16} data-id="element-136" />
              Refresh Data
            </button>
          </div>
        </div>

        {/* Key Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-137">
          {funnelData.map((stage, index) => <StageMetricCard key={stage.id} stage={stage} isLast={index === funnelData.length - 1} data-id="element-138" />)}
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-139">
          {/* Left Column: Funnel Visualization */}
          <div className="lg:col-span-1" data-id="element-140">
            <FunnelChart data={funnelData} data-id="element-141" />

            {/* Quick Insights Card */}
            <div className="mt-8 bg-blue-50 border border-blue-100 rounded-xl p-6" data-id="element-142">
              <h3 className="text-blue-900 font-semibold mb-2" data-id="element-143">
                Pipeline Insights
              </h3>
              <ul className="space-y-3 text-sm text-blue-800" data-id="element-144">
                <li className="flex items-start gap-2" data-id="element-145">
                  <span className="block w-1.5 h-1.5 rounded-full bg-blue-500 mt-1.5" data-id="element-146" />
                  Credit Pull conversion rate is down 5% this week.
                </li>
                <li className="flex items-start gap-2" data-id="element-147">
                  <span className="block w-1.5 h-1.5 rounded-full bg-blue-500 mt-1.5" data-id="element-148" />
                  "Referral Program" has the highest ROI at 850%.
                </li>
                <li className="flex items-start gap-2" data-id="element-149">
                  <span className="block w-1.5 h-1.5 rounded-full bg-blue-500 mt-1.5" data-id="element-150" />
                  Bottleneck detected at Application stage.
                </li>
              </ul>
            </div>
          </div>

          {/* Right Column: Campaign Performance */}
          <div className="lg:col-span-2" data-id="element-151">
            <CampaignTable campaigns={campaignData} data-id="element-152" />
          </div>
        </div>
      </div>
    </div>;
}